import { Controller } from "react-hook-form";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { it } from 'date-fns/locale/it';
import ErrorMessageComponent from "../main/ErrorMessage";

import React from "react";

const DatePickerInput = React.forwardRef<HTMLInputElement, any>(
  ({ value, onClick, placeholder, id, disabled }, ref) => (
    <input
      ref={ref}
      value={value || ""}
      onClick={onClick}
      placeholder={placeholder}
      id={id}
      disabled={disabled}
      autoComplete="off"
      readOnly
      className={`${
        disabled ? "opacity-70" : ""
      } bg-[#efefef] rounded-md p-2 peer h-10 w-full text-skin-textInput placeholder-transparent focus:outline-none focus:border-skin-inputFocus text-base cursor-pointer`}
    />
  )
);

DatePickerInput.displayName = "DatePickerInput";


export default function DateAppointment({ input, form, isDisabled }: any) {
  const {
    control,
    formState: { errors },
  } = form;

  const parseDate = (dateString: string) => {
    if (!dateString) return null;
    const parts = dateString.split(" ");
    const dateParts = parts[0].split("-");
    const timeParts = parts[1] ? parts[1].split(":") : ["9", "0"];

    return new Date(
      parseInt(dateParts[2]),
      parseInt(dateParts[1]) - 1,
      parseInt(dateParts[0]),
      parseInt(timeParts[0]),
      parseInt(timeParts[1])
    );
  };

  const formatDate = (date: Date, includeTime: boolean) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    if (includeTime) {
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    }

    return `${day}-${month}-${year}`;
  };

  return (
    <div className={input.size_input}>
      <div className="relative">
        <Controller
          name={input?.name}
          control={control}
          rules={input.validators}
          render={({ field: { onChange, value } }) => (
            <ReactDatePicker
              selected={parseDate(value)}
              onChange={(date: Date | null) => {
                if (date) {
                  onChange(formatDate(date, input.isTimeShow));
                }
              }}
              showTimeSelect={input.isTimeShow}
              timeIntervals={15}
              timeCaption="Ora"
              dateFormat={
                input.isTimeShow ? "dd-MM-yyyy HH:mm" : "dd-MM-yyyy"
              }
              locale={it}
              disabled={isDisabled || input?.isDisabled}
              minDate={input?.isLimitDate ? new Date() : undefined}
              placeholderText={input?.placeholder}
              calendarClassName="custom-datepicker-styled"
              wrapperClassName="w-full"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              customInput={
                <DatePickerInput
                  id={input.name}
                  disabled={isDisabled || input?.isDisabled}
                />
              }
            />
          )}
        />

        <label
          htmlFor={input?.name}
          className={`${
            isDisabled || input?.isDisable ? "opacity-70" : ""
          } pointer-events-none select-none absolute text-base left-2 -top-4 text-[#064e3b] transition-all
          peer-placeholder-shown:top-3
          peer-placeholder-shown:text-[#9CA3AF]
          peer-focus:-top-4
          peer-focus:text-skin-focus`}
        >
          {input.label}
        </label>
      </div>

      <ErrorMessageComponent errors={errors} name={input?.name} />
    </div>
  );
}
